export default {"src":"/_next/static/media/ETR.2186c33b.svg","height":18,"width":18};